import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box
} from '@mui/material';
import { useCreateLead } from '../../hooks/useLeads';

interface AddLeadDialogProps {
  open: boolean;
  onClose: () => void;
}

const AddLeadDialog: React.FC<AddLeadDialogProps> = ({ open, onClose }) => {
  const [formData, setFormData] = useState({
    companyName: '',
    industry: '',
    contactName: '',
    city: '',
    postcode: '',
    phone: '',
    address1: '',
    address2: '',
    address3: '',
    email: ''
  });

  const createLead = useCreateLead();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createLead.mutateAsync(formData);
      onClose();
      setFormData({
        companyName: '',
        industry: '',
        contactName: '',
        city: '',
        postcode: '',
        phone: '',
        address1: '',
        address2: '',
        address3: '',
        email: ''
      });
    } catch (error) {
      
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Add New Contact</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <TextField
              name="companyName"
              label="Company Name"
              value={formData.companyName}
              onChange={handleChange}
              fullWidth
              required
              margin="normal"
            />
            <TextField
              name="contactName"
              label="Contact Name"
              value={formData.contactName}
              onChange={handleChange}
              fullWidth
              required
              margin="normal"
            />
            <TextField
              name="industry"
              label="Industry"
              value={formData.industry}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              name="city"
              label="City"
              value={formData.city}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              name="postcode"
              label="Postcode"
              value={formData.postcode}
              onChange={handleChange}
              fullWidth
              margin="normal"
              inputProps={{
                pattern: '^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$',
                title: 'Please enter a valid UK postcode'
              }}
            />
            <TextField
              name="phone"
              label="Phone"
              value={formData.phone}
              onChange={handleChange}
              fullWidth
              margin="normal"
              inputProps={{
                pattern: '^[\\d\\s+()-]+$',
                title: 'Please enter a valid phone number'
              }}
            />
            <TextField
              name="address1"
              label="Address Line 1"
              value={formData.address1}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              name="address2"
              label="Address Line 2"
              value={formData.address2}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              name="address3"
              label="Address Line 3"
              value={formData.address3}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              name="email"
              label="Email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            type="submit"
            variant="contained"
            disabled={!formData.companyName || !formData.contactName}
          >
            Add Contact
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddLeadDialog;
